export enum TicketDataQueryKeys {
  DETAILS = "ticketDetails",
  ATTACHMENT = "ticketDetailsAttachment",
  UPDATE = "updateTicket",
}
